(function ($, document, window) {
	'use strict';

	$(function () {
		const $carousel = $('.js-review-collection');
		const $courseContainer = $('.js-single-course-container');
		const isInsideCourseContainer = $courseContainer.has($carousel).length > 0;

		const swiper = new Swiper('.js-review-collection', {
			direction: 'horizontal',
			slidesPerView: 1.25,
			grabCursor: true,
			centerInsufficientSlides: isInsideCourseContainer ? false : true,

			breakpoints: isInsideCourseContainer ? {
				460: { slidesPerView: 1.75 },
				1024: { slidesPerView: 3 },
			} : {
				460: { slidesPerView: 1.75 },
				1024: { slidesPerView: 3 },
				1280: { slidesPerView: 4 },
				1440: { slidesPerView: 5 },
			},
		});
	});
})(jQuery, document, window);
